// extracted by mini-css-extract-plugin
module.exports = {"grade-total":"Compressions_grade-total__YNvXd","label-text":"Compressions_label-text__9N9mB","container":"Compressions_container__34vj4"};